import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useLocation, useParams } from 'react-router-dom'
import { history } from '../../../helpers'
import PdcaSidebar from './pdcaSidebar'
import PdcaHeaderContexto from './pdcaHeaderContexto'
import './pdcaLayout.scss'

export default ({ children }) => {
  const location = useLocation()
  const { idProjetos } = useParams()

  const {
    projetoId,
    empresaPdcaExiste,
    contextoCarregado
  } = useSelector(state => state.pdcaState.pdcaBaseState)

  const pathname = location.pathname

  const estaNoSetup = pathname.includes('/pdca/setup')
  const estaNaEntradaPdca =
    pathname === `/myprojects/${idProjetos}/pdca`

  const ehCallbackTrello =
    pathname === `/myprojects/${idProjetos}/pdca/integration/trello-callback`

  const ehCallbackClickup =
    pathname === `/myprojects/${idProjetos}/pdca/integration/clickup-callback`

  const [sidebarMobileOpen, setSidebarMobileOpen] = useState(false)

  const paracompilar = 3;

  const podeSeguirSemRedirecionar =
    ehCallbackTrello || ehCallbackClickup 

  const contextoValido =
    contextoCarregado &&
    String(projetoId) === String(idProjetos)

  const precisaVoltarParaEntrada =
    !estaNaEntradaPdca &&
    !contextoValido &&
    !podeSeguirSemRedirecionar

  useEffect(() => {
    const boxContainer = document.getElementById('box-container')
    const boxContainerPage = document.getElementById('box-container-page')

    if (boxContainer) {
      boxContainer.classList.add('box-container-pdca')
    }

    if (boxContainerPage) {
      boxContainerPage.classList.add('box-container-page-pdca')
    }

    return () => {
      if (boxContainer) {
        boxContainer.classList.remove('box-container-pdca')
      }

      if (boxContainerPage) {
        boxContainerPage.classList.remove('box-container-page-pdca')
      }
    }
  }, [])


  useEffect(() => {
    setSidebarMobileOpen(false)
  }, [pathname])


  useEffect(() => {
    if (precisaVoltarParaEntrada) {
      history.push(`/myprojects/${idProjetos}/pdca`)
    }
  }, [precisaVoltarParaEntrada, idProjetos])

  if (precisaVoltarParaEntrada) {
    return null
  }

  const exibirSidebar = empresaPdcaExiste && !estaNoSetup
  const exibirHeaderContexto = !estaNoSetup

  return (
    <div className={`box-pdca-layout ${!exibirSidebar ? 'box-pdca-layout-no-sidebar' : ''}`}>
      {exibirSidebar ? (

        <div
  className={`box-pdca-layout-sidebar ${sidebarMobileOpen ? 'open-sidebar' : ''}`}
  data-cy='pdca-sidebar'
  data-cy-open={sidebarMobileOpen ? 'true' : 'false'}
>
  <PdcaSidebar sidebarMobileOpen={sidebarMobileOpen} />
</div>


      ) : null}

      <div className='box-pdca-layout-content'>
        {exibirSidebar ? (
          <button
  type='button'
  data-cy='pdca-sidebar-toggle'
  data-cy-open={sidebarMobileOpen ? 'true' : 'false'}
  className='box-pdca-layout-mobile-menu-btn'
  onClick={() => setSidebarMobileOpen(!sidebarMobileOpen)}
>
  ☰
</button>
        ) : null}

        {exibirHeaderContexto ? <PdcaHeaderContexto /> : null}

        <div className='box-pdca-layout-body'>
          {children}
        </div>
      </div>

    </div>
  )
}